import axios from "axios"
import authHeader from './AuthHeader'
import { API_URL } from '../config/api'

class AuthService {

  login = async (username, password) => {
    return await axios
      .post(API_URL + "/auth/login", {
        email: username,
        password: password
      })

  }

  logout = async () => {
    const headers = authHeader()
    return await axios.delete(API_URL + '/auth/logout', { headers: headers })
  }

  getCurrentUser = () => {
    return JSON.parse(localStorage.getItem('user')) || false
  }

  removeCurrentUser = () => {
    localStorage.removeItem("user")
  }
}

export default new AuthService()